document.addEventListener("alpine:init", () => {
    Alpine.data("openable", () => ({
        open: false,
    }));
});

window.initFooterLinkColumns = () => {
    const footer = document.querySelector(".footer-container");
    
    if (!footer) {
        return;
    }

    const footerLinkColumns = footer.querySelectorAll(".footer-link-column");

    if (!footerLinkColumns || !footerLinkColumns.length) {
        return;
    }

    const setupCollapsible = (column) => {
        const headings = column.querySelectorAll(".wp-block-heading");
        
        if (!headings) {
            return;
        }

        const getLinkHeight = (group) => {
            const links = group.querySelectorAll("p");
            let height = 0;

            links.forEach((link) => {
                const style = window.getComputedStyle(link);
                height += link.offsetHeight;
                height += parseInt(style.marginBottom);
            });

            return height;
        };

        headings.forEach((heading) => {
            const group = heading.nextElementSibling;
            
            // Remove existing event listeners
            const newHeading = heading.cloneNode(true);
            heading.parentNode.replaceChild(newHeading, heading);
            
            // Reset styles
            group.style.height = window.innerWidth >= 1024 ? 'auto' : '0px';
            newHeading.classList.remove('-open');
            
            if (window.innerWidth < 1024) {
                newHeading.addEventListener("click", (e) => {
                    const height = getLinkHeight(group);

                    if (newHeading.classList.contains("-open")) {
                        group.style.height = "0px";
                        newHeading.classList.remove("-open");
                    } else {
                        group.style.height = height + "px";
                        newHeading.classList.add("-open");
                    }
                });
            }
        });
    };

    footerLinkColumns.forEach(setupCollapsible);
};

// Initialize on load
window.onload = () => {
    window.initFooterLinkColumns();
};

// Handle resize events
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        window.initFooterLinkColumns();
    }, 250);
});

document.addEventListener("alpine:init", () => {
    Alpine.data("tableOfContents", () => ({
        headings: {},
        currentLink: null,
        lastScrollTop: 0,

        init() {
            this.addIdsToHeadings();
            this.addAnchorsToLinks();
            this.checkPosition(true);

            window.addEventListener('scroll', () => {
                this.checkPosition();
            });
        },

        addIdsToHeadings() {
            const headings = document.querySelectorAll("article h2");

            headings.forEach((heading) => {
                let id = heading.innerText.toLowerCase().replace(/\s/g, "-");
                id = id.replace(/[^a-zA-Z0-9-]/g, "");
                heading.id = id;

                this.headings[id] = heading.innerText;
            });
        },

        addAnchorsToLinks() {
            const links = this.$root.querySelectorAll("a");

            Object.entries(this.headings).forEach(([id, text]) => {
                links.forEach((link) => {
                    if (link.innerText === text) {
                        link.href = `#${id}`;
                    }
                });
            });
        },

        checkPosition(onLoad = false) {
            const contentRows = document.querySelectorAll("article h2");
            const windowOffset = window.innerHeight / 3;
            const scrollPosition = window.scrollY;
            const viewportMiddle = window.innerHeight / 2;

            let foundActive = false;
            let closestSection = null;
            let smallestDistance = Infinity;

            contentRows.forEach((row) => {
                if (!row.id) return;

                const rect = row.getBoundingClientRect();
                const rowMiddle = rect.top + (rect.height / 2);
                const distance = Math.abs(viewportMiddle - rowMiddle);

                if (distance < smallestDistance) {
                    smallestDistance = distance;
                    closestSection = row;
                }

                if (rect.top <= windowOffset && rect.bottom >= 0) {
                    this.currentLink = "#" + row.id;
                    foundActive = true;
                }
            });

            if (!foundActive && closestSection) {
                this.currentLink = "#" + closestSection.id;
            }
            else if (!foundActive && scrollPosition <= 0) {
                const allLinks = this.$root.querySelectorAll("a");
                if (allLinks.length > 0) {
                    this.currentLink = allLinks[0].getAttribute("href");
                }
            }
        },
    }));
});